export default __webpack_public_path__ + "static/17-afa0e99f306a18cda6baabc6a880a9c4.jpg";